module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('page-header', {
    attrs: {
      "cids": _vm.cids,
      "isLogin": _vm.loginSys.isLogin,
      "userName": _vm.userInfo.name
    }
  }), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [_c('router-view')], 1), _c('page-footer'), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-login",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      },
      "close": _vm.dialogLoginClose
    }
  }, [(_vm.loginSys.stat === 'login') ? _c('login') : _vm._e(), (_vm.loginSys.stat === 'signup') ? _c('signup') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5c7f94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 997
// module chunks = 1